import apiClient from './apiClient';
import { format, startOfMonth, endOfMonth } from 'date-fns';

function withTenantQuery(params, tenantId) {
    const p = { ...params };
    if (tenantId != null && !Number.isNaN(tenantId)) {
        p.tenant_id = tenantId;
    }
    return p;
}

// Activity Endpoints
export const getActivities = async (params = {}, { tenantId = null } = {}) => {
    try {
        const response = await apiClient.get('/planning/activities', {
            params: withTenantQuery(params, tenantId),
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getActivityById = async (id, { tenantId = null, includeDeleted = false } = {}) => {
    try {
        const params = includeDeleted ? { include_deleted: true } : {};
        const response = await apiClient.get(`/planning/activities/${id}`, {
            params: withTenantQuery(params, tenantId),
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createActivity = async (activityData, { tenantId = null } = {}) => {
    try {
        const response = await apiClient.post('/planning/activities', activityData, {
            params: withTenantQuery({}, tenantId),
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateActivity = async (id, activityData, { tenantId = null } = {}) => {
    try {
        const response = await apiClient.put(`/planning/activities/${id}`, activityData, {
            params: withTenantQuery({}, tenantId),
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Template Endpoints
export const getTemplates = async () => {
    try {
        const response = await apiClient.get('/planning/templates');
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getTemplateById = async (id) => {
    try {
        const response = await apiClient.get(`/planning/templates/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createTemplate = async (templateData) => {
    try {
        const response = await apiClient.post('/planning/templates', templateData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const instantiateTemplate = async (templateId, startDate, { tenantId = null } = {}) => {
    try {
        const response = await apiClient.post(
            `/planning/templates/${templateId}/instantiate`,
            { start_date: startDate },
            { params: withTenantQuery({}, tenantId) }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// export const getCalendarActivities = async (params = {}) => {
//     try {
//         const response = await apiClient.get('/planning/calendar', { params });
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const getCalendarActivities = async (params = {}) => {
//     try {
//         // Ensure we always send start_date and end_date
//         const defaultParams = {
//             start_date: format(new Date(), 'yyyy-MM-dd'),
//             end_date: format(new Date(new Date().setMonth(new Date().getMonth() + 1)), 'yyyy-MM-dd')
//         };

//         const finalParams = { ...defaultParams, ...params };

//         const response = await apiClient.get('/planning/calendar', {
//             params: finalParams,
//             paramsSerializer: params => {
//                 return Object.entries(params)
//                     .map(([key, value]) => `${key}=${value}`)
//                     .join('&');
//             }
//         });
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

export const getCalendarActivities = async (params = {}) => {
    try {
        // Set default date range to current month if not provided
        const today = new Date();
        const defaultParams = {
            start_date: format(startOfMonth(today), 'yyyy-MM-dd'),
            end_date: format(endOfMonth(today), 'yyyy-MM-dd')
        };

        // Merge provided params with defaults
        const finalParams = { ...defaultParams, ...params };

        const response = await apiClient.get('/planning/calendar', {
            params: finalParams
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Utility functions for dropdown options
export const getActivityTypeOptions = () => {
    return ['Crop', 'Livestock', 'Maintenance', 'Administrative'];
};

export const getPriorityOptions = () => {
    return ['Low', 'Medium', 'High'];
};

export const getStatusOptions = () => {
    return ['Planned', 'In Progress', 'Completed', 'Cancelled'];
};

export const getSeasonOptions = () => {
    return ['Dry Season', 'Wet Season', 'Harvest Season', 'Planting Season'];
};

export const getRecurrencePatternOptions = () => {
    return ['Daily', 'Weekly', 'Monthly', 'Yearly'];
};